import {
  ChangelogEventType,
  ChangelogEventTypeColorMap,
  ChangelogEventTypeTextMap,
} from "../../../utils/types";
import { Badge } from "@merge-api/merge-javascript-shared";

type EventCellProps = {
  eventType: ChangelogEventType;
};
const EventCell = ({ eventType }: EventCellProps) => {
  // const derived from state
  const color = ChangelogEventTypeColorMap[eventType];
  const text = ChangelogEventTypeTextMap[eventType];

  return (
    <td>
      <Badge size="md" color={color}>
        {text}
      </Badge>
      {eventType == ChangelogEventType.CANARY_TEST_AUTO_ROLLBACK && (
        <div className="text-xs text-gray-40 flex-wrap pt-1">
          Rolled back due to no action for 24 hours
        </div>
      )}
    </td>
  );
};

export default EventCell;
